import { AfterViewInit, Component, inject, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SVG_ICONS } from "../../../models/icons";
import { SanitizerPipe } from "../../../pipes/sanitizer.pipe";
import { FormsModule } from "@angular/forms";
import { MasterService } from "../../../serivces/master.service";
import { GlobalService } from "../../../serivces/global.service";
import { ActivatedRoute, Router } from "@angular/router";
import { catchError, tap } from "rxjs/operators";
import { of, Subject, Subscription } from "rxjs";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { environment } from "@frontend/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { UploadResultDialogComponent } from "./upload-result-dialog/upload-result-dialog.component";

interface Student {
  StudentID: number;
  FirstName: string;
  MiddleName: string | null;
  LastName: string;
  Email: string;
  MobileNo: string;
  DOB: string | null;
  Height: string;
  Weight: string;
  batch: string;
  classEnrollments: Array<{
    StudentClassID: number;
    ClassID: number;
    StudentID: number;
    IsActive: boolean;
  }>;
  packageSubscriptions: Array<{
    packageDetails: {
      PackageName: string;
      EndTime: string;
    };
  }>;
  CurrentActivePackage?: {
    packageDetails: {
      PackageName: string;
      EndTime: string;
    };
  };
  Last3DaysAttendance: string | null; // Allow null value
  age: number;
  membershipPlan: {
    PackageName: string;
    EndTime: string;
  } | null;
  belt?: {
    BeltName: string;
    BeltColor: string;
  };
  center?: {
    CenterName: string;
  };
}

@Component({
  selector: "app-members",
  imports: [CommonModule, SanitizerPipe, FormsModule, SharedModule],
  templateUrl: "./members-list.component.html",
  styleUrl: "./members-list.component.scss",
})
export class MembersComponent implements AfterViewInit, OnDestroy {
  private masterService = inject(MasterService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private globalService = inject(GlobalService);
  private searchSubscription?: Subscription;

  ngAfterViewInit() {
    this.paginator.page.pipe(tap(() => this.getStudent(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction))).subscribe();
    this.sort.sortChange.subscribe(() => {
      this.getStudent(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
    });

    this.searchSubscription = this.globalService.setupDebouncedSearch(this.searchSubject, searchValue => {
      this.searchString = searchValue;
      this.paginator.pageIndex = 0;
      this.getStudent(1, this.paginator.pageSize, this.sort.active, this.sort.direction);
    });

    this.getStudent(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
  }

  //#region variables

  readonly SVG_ICONS = SVG_ICONS;
  studentList: Student[] = [];
  searchString: string = "";
  private searchSubject = new Subject<string>();
  filteredStudents: Student[] = [];
  MembershipPlan: any;
  displayedColumns: string[] = ["FirstName", "email", "DOB", "height", "weight", "BeltName", "membership", "CenterName", "actions"];
  Pagelength = 0;
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  activeClass: any;

  //#endregion

  // getAttendanceIcons(attendanceData: string | null): string[] {
  //   if (!attendanceData || attendanceData === "[]") {
  //     return ["ABSENT_ATTENDENCE_ICON", "ABSENT_ATTENDENCE_ICON", "ABSENT_ATTENDENCE_ICON"];
  //   }

  //   try {
  //     const attendanceRecords = JSON.parse(attendanceData) as any[];

  //     const today = new Date();
  //     const dates = [
  //       today.toISOString().split("T")[0],
  //       new Date(today.setDate(today.getDate() - 1)).toISOString().split("T")[0],
  //       new Date(today.setDate(today.getDate() - 1)).toISOString().split("T")[0],
  //     ];

  //     const icons: string[] = dates.map(date => {
  //       const record = attendanceRecords.find(record => record && typeof record === "object" && record.AttendanceDate === date);
  //       if (record && record.AttendanceStatus === "Present") {
  //         return "PRESENT_ATTENDENCE_ICON";
  //       }

  //       return "ABSENT_ATTENDENCE_ICON";
  //     });

  //     return icons;
  //   } catch (error: any) {
  //     console.error("Error parsing attendance data:", error.message);
  //     return ["ABSENT_ATTENDENCE_ICON", "ABSENT_ATTENDENCE_ICON", "ABSENT_ATTENDENCE_ICON"];
  //   }
  // }

  getStudent(pageIndex: number, pageSize: number, sortColumn: string, sortDirection: string) {
    const sort = sortColumn ? `${sortColumn} ${sortDirection}` : "StudentID desc";

    this.masterService
      .getStudentList(pageIndex, pageSize, sort.toString(), sessionStorage.getItem("selectedCenter") || "", "", "", this.searchString)
      .pipe(
        catchError((error: unknown) => {
          console.error("Error fetching student list:", error);
          return of({ Table: [], TotalCount: 0 });
        })
      )
      .subscribe((res: any) => {
        const { Table, TotalCount } = res;
        const studentsWithAttendance = Table.map((student: Student) => ({
          ...student,
          age: this.calculateAge(student.DOB),
          membershipPlan: student.packageSubscriptions?.[0]?.packageDetails || null,
          Last3DaysAttendance: "[]",
        }));

        studentsWithAttendance.forEach((student: Student) => {
          if (!Array.isArray(student.classEnrollments)) {
            return;
          }

          const activeClass = student.classEnrollments.find((enrollment: { IsActive: boolean }) => enrollment.IsActive);

          if (activeClass) {
            const today = new Date().toISOString().split("T")[0];

            // this.masterService.getStudentAttendence(activeClass.ClassID, today).subscribe({
            //   next: (attendanceRecords: any[]) => {
            //     if (!Array.isArray(attendanceRecords)) {
            //       return;
            //     }

            //     const attendanceData = attendanceRecords.find((record: any) => record.StudentID === student.StudentID);

            //     if (attendanceData) {
            //       student.Last3DaysAttendance = attendanceData.Last3DaysAttendance || "[]";
            //     }
            //   },
            //   error: (error: any) => {
            //     console.error(`Error fetching attendance for student ${student.StudentID}:`, error);
            //   },
            // });
          }
        });

        this.studentList = studentsWithAttendance;
        this.filteredStudents = [...studentsWithAttendance];
        this.Pagelength = TotalCount;

        const filteredByCenter = this.studentList;

        this.studentList = filteredByCenter;
        this.filteredStudents = [...filteredByCenter];
        this.dataSource.data = [...filteredByCenter];
      });
  }

  calculateAge(dob: string | null): number {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const hasBirthdayPassedThisYear = today.getMonth() > birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!hasBirthdayPassedThisYear) {
      age--;
    }

    return age;
  }

  isPaymentCompleted(student: any): boolean {
    if (!student || !Array.isArray(student.classEnrollments)) {
      return false;
    }

    const activeEnrollment = student.classEnrollments.find((enrollment: any) => enrollment.IsActive === true);

    return activeEnrollment ? activeEnrollment.IsPaymentDone === true : false;
  }
  onActionClick(studentID: number) {
    this.router.navigate(["student/student-details"], { queryParams: { StudentID: studentID } });
  }

  onEdit(studentID: number) {
    this.router.navigate(["student/add-student"], { queryParams: { StudentID: studentID } });
  }

  onAddPayment(student: Student) {
    const activeEnrollment = student.classEnrollments?.find(e => e.IsActive);
    this.activeClass = activeEnrollment;
    if (!activeEnrollment) {
      console.warn(`No active class found for student ${student.StudentID}`);
      return;
    }

    this.router.navigate(["student/add-payment"], {
      queryParams: {
        StudentID: student.StudentID,
        ClassID: activeEnrollment.ClassID,
      },
    });
  }

  getProfileImageUrl(documents: any[] | null | undefined): string {
    if (!documents || documents.length === 0) return "public/no-image.jpg";

    const profileDoc = documents.find(doc => doc?.doc_type === "Profile" || doc?.DocumentCategory === "Profile");

    if (!profileDoc?.URL) return "public/no-image.jpg";

    return profileDoc.URL.startsWith("http") ? profileDoc.URL : `${environment.img}${profileDoc.URL}`;
  }

  getActiveClass(student: any): any {
    return (student.classEnrollments || []).find((cls: any) => cls.IsActive)?.classDetails || null;
  }

  getActivePackage(student: any): any {
    return student.CurrentActivePackage?.packageDetails || "-";
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.searchSubject.next(filterValue);
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.masterService.bulkUploadStudents(file).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.dialog.open(UploadResultDialogComponent, {
              data: {
                message: res.message,
                createdStudents: res.createdStudents,
                existingStudents: res.existingStudents,
                errors: res.errors,
              },
              width: "600px",
            });
            // Refresh the list
            this.getStudent(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
          }
        },
        error: (err: any) => {
          console.error("Upload failed", err);
          alert("Upload failed: " + err.message);
        },
      });
    }
  }

  triggerFileUpload() {
    const fileInput = document.getElementById("fileUpload") as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  getBeltTextColor(hexColor: string | undefined): string {
    if (!hexColor) return "white";
    let hex = hexColor.replace("#", "");
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map(char => char + char)
        .join("");
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? "black" : "white";
  }

  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
  }
}
